import { z } from 'zod';
import { PaginatedResponse } from './api';
import type { ExtendedBaseUser } from './users';

export const clanSchema = z.object({
    id: z.uuidv4(),
    global_name: z.string(),
    tag: z.string(),
    description: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
});

export type Clan = z.input<typeof clanSchema>;

export type ClansResponse = PaginatedResponse<Clan>;

export type ClanMember = ExtendedBaseUser & {
    role: number;
    created_at: string;
};

export type ClanMemberWithContributedPoints = ClanMember & {
    contributed_points?: number;
};

export type ClanInvite = {
    id: string;
    clan_id: string;
    user_id: string;
    invited_by: string;
    created_at: string;
    updated_at: string;
    clan: Clan;
};
